import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AlertCircle } from 'lucide-react';

export default function CancelFromDateDialog({
  open, onOpenChange, futureBookingDates, fromDate, setFromDate, onConfirm, submitting,
  notifyCustomer = true,
}) {
  const matched = futureBookingDates.filter((d) => d >= fromDate);
  const min = futureBookingDates[0] || '';
  const max = futureBookingDates[futureBookingDates.length - 1] || '';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="cancel-from-date-dialog">
        <DialogHeader>
          <DialogTitle>Cancel From Date Onward</DialogTitle>
        </DialogHeader>

        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            All upcoming bookings on or after this date will be cancelled. Earlier bookings stay confirmed.
          </p>

          <div>
            <Label className="text-xs uppercase font-bold text-muted-foreground mb-2 block">From Date</Label>
            <Input
              type="date"
              value={fromDate}
              min={min}
              max={max}
              onChange={(e) => setFromDate(e.target.value)}
              data-testid="cancel-from-date-input"
            />
          </div>

          <div className="p-3 rounded-md border border-amber-200 bg-amber-50 text-sm text-amber-900">
            <AlertCircle className="w-4 h-4 inline mr-1" />
            <strong>{matched.length}</strong> booking{matched.length === 1 ? '' : 's'} will be cancelled.
            Series end date will move to the day before <strong>{fromDate || '—'}</strong>.
          </div>

          <div
            className="text-xs text-slate-600"
            data-testid="notify-customer-status"
          >
            {notifyCustomer
              ? '📧 Customer will receive an updated email summary (with cancelled + still-confirmed sessions).'
              : '🔕 Customer will NOT be emailed. Toggle the option above to enable.'}
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={submitting} data-testid="cancel-from-date-back">
            Back
          </Button>
          <Button
            onClick={onConfirm}
            disabled={submitting || !fromDate || matched.length === 0}
            className="bg-rose-600 hover:bg-rose-700 text-white"
            data-testid="cancel-from-date-confirm"
          >
            {submitting ? 'Cancelling…' : `Cancel ${matched.length} Booking${matched.length === 1 ? '' : 's'}`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
